var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4024 16.218V10.746H14.9304V13.14H17.7204V14.94C17.0184 15.444 16.1184 15.696 15.1104 15.696C12.8784 15.696 11.2944 14.004 11.2944 11.7V11.664C11.2944 9.522 12.8964 7.74 14.9124 7.74C16.3704 7.74 17.2344 8.208 18.2064 9.018L19.9524 6.912C18.6384 5.796 17.2704 5.184 15.0024 5.184C11.1864 5.184 8.39638 8.118 8.39638 11.7V11.736C8.39638 15.462 11.0964 18.216 15.0204 18.216C17.3244 18.216 19.1064 17.316 20.4024 16.218ZM11.0864 29V22H9.56637V26.31L6.28637 22H4.86637V29H6.38637V24.55L9.77637 29H11.0864ZM18.0968 23.4V22H12.7668V29H14.3068V26.29H17.6468V24.89H14.3068V23.4H18.0968ZM24.6293 23.42V22H18.8293V23.42H20.9593V29H22.4993V23.42H24.6293Z",
    fill: "#DA18A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b73696092c734d38dbfbb7aa96587d31.svg";
export { ForwardRef as ReactComponent };